import { atom } from 'recoil';

const apiLoadingState = atom({
  key: 'apiLoadingStateKey',
  default: true,
});

export default apiLoadingState;
